import styled from 'styled-components';
import { Nav, NavItem, FormGroup, Row, Form } from "react-bootstrap";

export const GridWrapper = styled.div`
    width: 100%;
    height: 66vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    div.ag-root .ag-cell-focus {
        user-select: text !important;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #ccc;
    }

    .list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
    }

    .list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-color: #eee;
        border-width: 0px 0px 0px 1px;
        border-style: solid;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    @media screen and (width < 1680px) {
        font-size: 12px;
    }
`;

export const RowWrapper = styled(Row)`
    margin-bottom: 10px;
    display: flex;
    align-items: center;
`;

export const ViewWrapper = styled(Form)`
    width: 99%;
    
    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    // display: flex;
    // align-items: center;

    // & > .col-lg-3 {
    //     padding-left: 0px;
    // }
`;

export const FormWrapper = styled(Form)`
    padding-left: 20px;
    
    label {
        margin-bottom: 0px;
    }
`;